import React from 'react';
import { LendingDivSupport } from '../component/lending/LendingDivSupport';

export const LendingSuppportPage = () => <LendingDivSupport />;
